
import React from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import useModalAsignarVacaciones from "../hooks/useModalAsignarVacaciones";
import { Toaster } from "react-hot-toast";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";

export default function ModalAsignarVacaciones({ show, handleClose }) {

    const { cantidad, handleChange,
        guardar, setCantidad,guardando, cantidadDeDias
    } = useModalAsignarVacaciones(handleClose)
    const setEditarVacacionesEmpleado = useEmpleadoStore(state => state.setEditarVacacionesEmpleado)
    const diasVacaciones = useEmpleadoStore(state => state.diasVacaciones)
    const diasVacacionesSumados = useEmpleadoStore(state => state.diasVacacionesSumados)


	const RenderAlerta = () => {
		if (diasVacaciones - diasVacacionesSumados < cantidadDeDias) {
			return (<Alert variant="info">
				A este empleado le restan { diasVacaciones - diasVacacionesSumados } días de vacaciones. Asignaste {cantidadDeDias}.
			</Alert>)
		}
		return ''
	}


    return (
        <>
            <Modal backdrop="static" show={show} onHide={() => {
                handleClose();
                setEditarVacacionesEmpleado({});
            }} size="lg" onExited={() => setCantidad([{ inicio: "", fin: "" }])} >
                <form id="formAsignarVacaciones" onSubmit={ e => {
                    e.preventDefault()
                    guardar()
                }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Asignar vacaciones</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div className="row col-12">
                            <Form.Group className="mb-3 col-12 col-md-6" controlId={`inicioVacaciones`}>
                                <Form.Label>Inicio de vacaciones</Form.Label>
                                <Form.Control type="date" required={true} value={cantidad[0].inicio} onChange={e => handleChange(e.target.value, 0, 'inicio')}  />
                            </Form.Group>

                            <Form.Group className="mb-3 col-12 col-md-6" controlId={`finVacaciones`}>
                                <Form.Label>Fin de vacaciones</Form.Label>
                                <Form.Control type="date" required={true} value={cantidad[0].fin} onChange={e => handleChange(e.target.value, 0, 'fin')}  />
                            </Form.Group>
                            <div className="col-12 col-md-2 align-self-end mb-3">
                            </div>
                        </div>

						<div className="row col-12">
							{/* mensaje para decirle que agregó días de más */}
							<RenderAlerta/>
							{/* {!cantidadDeDias && <Alert variant="info">
								No se pueden asignar más de { diasVacaciones - diasVacacionesSumados } días. Asignaste {cantidadDeDias}.
							</Alert>} */}
						</div>



                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cerrar
                        </Button>
                        <Button variant="primary" type="submit" disabled={guardando}>
                            {guardando ? 'Guardando...' : 'Guardar'}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Toaster />
        </>
    )
}

